import { Link } from "react-router-dom";
import { Instagram, Music2 } from "lucide-react";

const IG = "https://www.instagram.com/intention_emmy?igsh=bGRvYjNsc295aG50&utm_source=qr";
const TT = "https://www.tiktok.com/@emmy_bydesign?_r=1&_t=ZP-96wMDajf4eN";

const EXPLORE = [
  { id: "story", label: "My Story" },
  { id: "shop", label: "Shop My Favorites" },
  { id: "letter", label: "The Thursday Edit" },
  { id: "connect", label: "Work With Me" },
];

export default function SiteFooter({ onNav }) {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer" id="footer" data-testid="site-footer">
      <div className="footer-top">
        <div className="footer-brand">
          <div className="fb-name">Emmy by design</div>
          <p className="fb-tag">
            Intentional living, motherhood &amp; culture — helping you design a life that supports
            the people you love and the person you're becoming.
          </p>
          <div className="footer-social">
            <a href={IG} target="_blank" rel="noreferrer" data-testid="footer-instagram" aria-label="Instagram">
              <Instagram size={18} strokeWidth={1.6} />
            </a>
            <a href={TT} target="_blank" rel="noreferrer" data-testid="footer-tiktok" aria-label="TikTok">
              <Music2 size={18} strokeWidth={1.6} />
            </a>
          </div>
        </div>

        <nav className="footer-col">
          <h4>Explore</h4>
          {EXPLORE.map((e) => (
            <button key={e.id} onClick={() => onNav(e.id)} data-testid={`footer-nav-${e.id}`}>
              {e.label}
            </button>
          ))}
        </nav>

        <div className="footer-col">
          <h4>The Thursday Edit</h4>
          <p className="fc-note">
            A thoughtful note in your inbox every Thursday. No spam — just intentional living.
          </p>
          <button className="footer-join" onClick={() => onNav("letter")} data-testid="footer-join">
            Join the list →
          </button>
        </div>
      </div>

      <div className="footer-disclosure">
        <p>
          Emmy by Design is a participant in affiliate programs, including the Amazon Services LLC
          Associates Program. As an Amazon Associate I earn from qualifying purchases. Some links are
          affiliate links, which means I may earn a small commission at no additional cost to you.
        </p>
      </div>

      <div className="footer-bottom">
        <span>© {year} Emmy by Design. All rights reserved.</span>
        <Link to="/admin/login" data-testid="admin-login-link" className="footer-studio">Studio</Link>
      </div>
    </footer>
  );
}
